import React from 'react';
import { Calendar } from 'lucide-react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';

function EventsCalendar({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section className="py-24 bg-white">
      <div className="container-page">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="eyebrow justify-center"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {items.map((e, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="card-surface p-7 hover:-translate-y-1 transition h-full">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent text-ink text-xs font-bold tracking-wider"><Calendar size={14} /> <EditableText value={e.date} onChange={(t) => updateItem(i, { date: t })} as="span" /></div>
                <EditableText value={e.title} onChange={(t) => updateItem(i, { title: t })} as="h4" className="font-display text-xl mt-4" />
                <EditableText value={e.detail} onChange={(t) => updateItem(i, { detail: t })} as="p" multiline className="mt-2 text-ink/70 text-sm leading-relaxed" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default EventsCalendar;
